import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Ittaskstestcases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.ittaskstestcases_Id,
          sortable: true,
          cell: (row) => <span>{row.ittaskstestcases_Id}</span>,
        },
        { name: "IT Tasks Id", selector: (row, i) => row.ittasks_Id, sortable: true, cell: (row) => <span>{row.ittasks_Id}</span>, }, { name: "Testcase Title", selector: (row, i) => row.testcase_title, sortable: true, cell: (row) => <span>{row.testcase_title}</span>, }, { name: "Testcase Description", selector: (row, i) => row.testcase_description, sortable: true, cell: (row) => <span>{row.testcase_description}</span>, }, { name: "Testcase Type", selector: (row, i) => row.testcase_type, sortable: true, cell: (row) => <span>{row.testcase_type}</span>, }, { name: "Priority", selector: (row, i) => row.priority, sortable: true, cell: (row) => <span>{row.priority}</span>, }, { name: "Excepted Results", selector: (row, i) => row.excepted_results, sortable: true, cell: (row) => <span>{row.excepted_results}</span>, }, { name: "Test Steps", selector: (row, i) => row.test_steps, sortable: true, cell: (row) => <span>{row.test_steps}</span>, }, { name: "Assigned To", selector: (row, i) => row.assigned_to, sortable: true, cell: (row) => <span>{row.assigned_to}</span>, }, { name: "Execution Notes", selector: (row, i) => row.execution_notes, sortable: true, cell: (row) => <span>{row.execution_notes}</span>, }, { name: "Failure Reason", selector: (row, i) => row.failurereason, sortable: true, cell: (row) => <span>{row.failurereason}</span>, }, { name: "Executed By", selector: (row, i) => row.executed_by, sortable: true, cell: (row) => <span>{row.executed_by}</span>, }, { name: "Executed On", selector: (row, i) => row.executed_on, sortable: true, cell: (row) => <span>{row.executed_on}</span>, }, { name: "Estimated Hours", selector: (row, i) => row.estimated_hours, sortable: true, cell: (row) => <span>{row.estimated_hours}</span>, }, { name: "Actual Hours", selector: (row, i) => row.actual_hours, sortable: true, cell: (row) => <span>{row.actual_hours}</span>, }, { name: "Environment", selector: (row, i) => row.environment, sortable: true, cell: (row) => <span>{row.environment}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.IttaskstestcaseseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      ittaskstestcases_Id: "",
      ittasks_Id: '', testcase_title: '', testcase_description: '', testcase_type: '', priority: '', excepted_results: '', test_steps: '', assigned_to: '', execution_notes: '', failurereason: '', executed_by: '', executed_on: '', estimated_hours: '', actual_hours: '', environment: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'ittasks_Id', inputType: 'Number', displayName: 'IT Tasks Id', validationOptions: { isRequired: false } },
      { fieldName: 'testcase_title', inputType: 'Text', displayName: 'Testcase Title', validationOptions: { isRequired: false } },
      { fieldName: 'testcase_description', inputType: 'Text', displayName: 'Testcase Description', validationOptions: { isRequired: false } },
      { fieldName: 'testcase_type', inputType: 'Text', displayName: 'Testcase Type', validationOptions: { isRequired: false } },
      { fieldName: 'priority', inputType: 'Text', displayName: 'Priority', validationOptions: { isRequired: false } },
      { fieldName: 'excepted_results', inputType: 'Text', displayName: 'Excepted Results', validationOptions: { isRequired: false } },
      { fieldName: 'test_steps', inputType: 'Text', displayName: 'Test Steps', validationOptions: { isRequired: false } },
      { fieldName: 'assigned_to', inputType: 'Number', displayName: 'Assigned To', validationOptions: { isRequired: false } },
      { fieldName: 'execution_notes', inputType: 'Text', displayName: 'Execution Notes', validationOptions: { isRequired: false } },
      { fieldName: 'failurereason', inputType: 'Text', displayName: 'Failure Reason', validationOptions: { isRequired: false } },
      { fieldName: 'executed_by', inputType: 'Number', displayName: 'Executed By', validationOptions: { isRequired: false } },
      { fieldName: 'executed_on', inputType: 'Date', displayName: 'Executed On', validationOptions: { isRequired: false } },
      { fieldName: 'estimated_hours', inputType: 'Text', displayName: 'Estimated Hours', validationOptions: { isRequired: false } },
      { fieldName: 'actual_hours', inputType: 'Text', displayName: 'Actual Hours', validationOptions: { isRequired: false } },
      { fieldName: 'environment', inputType: 'Text', displayName: 'Environment', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      ittasks_Id: '', testcase_title: '', testcase_description: '', testcase_type: '', priority: '', excepted_results: '', test_steps: '', assigned_to: '', execution_notes: '', failurereason: '', executed_by: '', executed_on: '', estimated_hours: '', actual_hours: '', environment: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      ittasks_Id: '', testcase_title: '', testcase_description: '', testcase_type: '', priority: '', excepted_results: '', test_steps: '', assigned_to: '', execution_notes: '', failurereason: '', executed_by: '', executed_on: '', estimated_hours: '', actual_hours: '', environment: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  IttaskstestcaseseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      ittaskstestcases_Id: row.ittaskstestcases_Id,
      ittasks_Id: row.ittasks_Id, testcase_title: row.testcase_title, testcase_description: row.testcase_description, testcase_type: row.testcase_type, priority: row.priority, excepted_results: row.excepted_results, test_steps: row.test_steps, assigned_to: row.assigned_to, execution_notes: row.execution_notes, failurereason: row.failurereason, executed_by: row.executed_by, executed_on: row.executed_on, estimated_hours: row.estimated_hours, actual_hours: row.actual_hours, environment: row.environment,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  IttaskstestcasesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Ittaskstestcases/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  IttaskstestcasessubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('ittasks_Id', this.state.ittasks_Id);
    formData.append('testcase_title', this.state.testcase_title);
    formData.append('testcase_description', this.state.testcase_description);
    formData.append('testcase_type', this.state.testcase_type);
    formData.append('priority', this.state.priority);
    formData.append('excepted_results', this.state.excepted_results);
    formData.append('test_steps', this.state.test_steps);
    formData.append('assigned_to', this.state.assigned_to);
    formData.append('execution_notes', this.state.execution_notes);
    formData.append('failurereason', this.state.failurereason);
    formData.append('executed_by', this.state.executed_by);
    formData.append('executed_on', this.state.executed_on);
    formData.append('estimated_hours', this.state.estimated_hours);
    formData.append('actual_hours', this.state.actual_hours);
    formData.append('environment', this.state.environment);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Ittaskstestcases/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstestcasesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ ittasks_Id: '', testcase_title: '', testcase_description: '', testcase_type: '', priority: '', excepted_results: '', test_steps: '', assigned_to: '', execution_notes: '', failurereason: '', executed_by: '', executed_on: '', estimated_hours: '', actual_hours: '', environment: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  IttaskstestcasesupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ittaskstestcases_Id", this.state.ittaskstestcases_Id);
    formData.append('ittasks_Id', this.state.ittasks_Id);
    formData.append('testcase_title', this.state.testcase_title);
    formData.append('testcase_description', this.state.testcase_description);
    formData.append('testcase_type', this.state.testcase_type);
    formData.append('priority', this.state.priority);
    formData.append('excepted_results', this.state.excepted_results);
    formData.append('test_steps', this.state.test_steps);
    formData.append('assigned_to', this.state.assigned_to);
    formData.append('execution_notes', this.state.execution_notes);
    formData.append('failurereason', this.state.failurereason);
    formData.append('executed_by', this.state.executed_by);
    formData.append('executed_on', this.state.executed_on);
    formData.append('estimated_hours', this.state.estimated_hours);
    formData.append('actual_hours', this.state.actual_hours);
    formData.append('environment', this.state.environment);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Ittaskstestcases/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstestcasesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.IttaskstestcasesfetchHandler();

    //***componentDidMount
  }

  handleittasks_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ittasks_Id: fieldValue });
  }; handletestcase_titleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_title: fieldValue });
  }; handletestcase_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_description: fieldValue });
  }; handletestcase_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_type: fieldValue });
  }; handlepriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  }; handleexcepted_resultsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ excepted_results: fieldValue });
  }; handletest_stepsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ test_steps: fieldValue });
  }; handleassigned_toChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assigned_to: fieldValue });
  }; handleexecution_notesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ execution_notes: fieldValue });
  }; handlefailurereasonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ failurereason: fieldValue });
  }; handleexecuted_byChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ executed_by: fieldValue });
  }; handleexecuted_onChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ executed_on: fieldValue });
  }; handleestimated_hoursChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ estimated_hours: fieldValue });
  }; handleactual_hoursChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actual_hours: fieldValue });
  }; handleenvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ environment: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this ittaskstestcases?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('ittaskstestcases_Id', row.ittaskstestcases_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Ittaskstestcases/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstestcasesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>IT Tasks Test Cases</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Ittaskstestcases</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>IT Tasks Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleittasks_IdChange} className="form-control" name="ittasks_Id" value={this.state.ittasks_Id} required="required" placeholder="Enter IT Tasks Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ittasks_Id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Testcase Title</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletestcase_titleChange} className="form-control" name="testcase_title" value={this.state.testcase_title} required="required" placeholder="Enter Testcase Title" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_title} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Testcase Description</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletestcase_descriptionChange} className="form-control" name="testcase_description" value={this.state.testcase_description} required="required" placeholder="Enter Testcase Description" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_description} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Testcase Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletestcase_typeChange} className="form-control" name="testcase_type" value={this.state.testcase_type} required="required" placeholder="Enter Testcase Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlepriorityChange} className="form-control" name="priority" value={this.state.priority} required="required" placeholder="Enter Priority" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Excepted Results</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleexcepted_resultsChange} className="form-control" name="excepted_results" value={this.state.excepted_results} required="required" placeholder="Enter Excepted Results" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.excepted_results} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Test Steps</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletest_stepsChange} className="form-control" name="test_steps" value={this.state.test_steps} required="required" placeholder="Enter Test Steps" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.test_steps} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Assigned To</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleassigned_toChange} className="form-control" name="assigned_to" value={this.state.assigned_to} required="required" placeholder="Enter Assigned To" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.assigned_to} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Execution Notes</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleexecution_notesChange} className="form-control" name="execution_notes" value={this.state.execution_notes} required="required" placeholder="Enter Execution Notes" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.execution_notes} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Failure Reason</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefailurereasonChange} className="form-control" name="failurereason" value={this.state.failurereason} required="required" placeholder="Enter Failure Reason" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failurereason} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Executed By</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleexecuted_byChange} className="form-control" name="executed_by" value={this.state.executed_by} required="required" placeholder="Enter Executed By" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.executed_by} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Executed On</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handleexecuted_onChange} className="form-control" name="executed_on" value={this.state.executed_on} required="required" placeholder="Enter Executed On" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.executed_on} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Estimated Hours</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleestimated_hoursChange} className="form-control" name="estimated_hours" value={this.state.estimated_hours} required="required" placeholder="Enter Estimated Hours" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.estimated_hours} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Actual Hours</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleactual_hoursChange} className="form-control" name="actual_hours" value={this.state.actual_hours} required="required" placeholder="Enter Actual Hours" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.actual_hours} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Environment</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleenvironmentChange} className="form-control" name="environment" value={this.state.environment} required="required" placeholder="Enter Environment" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.environment} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.IttaskstestcasessubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Ittaskstestcases</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>IT Tasks Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleittasks_IdChange} className="form-control" name="ittasks_Id" value={this.state.ittasks_Id} required="required" placeholder="Enter IT Tasks Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ittasks_Id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Testcase Title</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletestcase_titleChange} className="form-control" name="testcase_title" value={this.state.testcase_title} required="required" placeholder="Enter Testcase Title" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_title} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Testcase Description</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletestcase_descriptionChange} className="form-control" name="testcase_description" value={this.state.testcase_description} required="required" placeholder="Enter Testcase Description" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_description} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Testcase Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletestcase_typeChange} className="form-control" name="testcase_type" value={this.state.testcase_type} required="required" placeholder="Enter Testcase Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.testcase_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlepriorityChange} className="form-control" name="priority" value={this.state.priority} required="required" placeholder="Enter Priority" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Excepted Results</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleexcepted_resultsChange} className="form-control" name="excepted_results" value={this.state.excepted_results} required="required" placeholder="Enter Excepted Results" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.excepted_results} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Test Steps</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletest_stepsChange} className="form-control" name="test_steps" value={this.state.test_steps} required="required" placeholder="Enter Test Steps" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.test_steps} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Assigned To</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleassigned_toChange} className="form-control" name="assigned_to" value={this.state.assigned_to} required="required" placeholder="Enter Assigned To" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.assigned_to} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Execution Notes</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleexecution_notesChange} className="form-control" name="execution_notes" value={this.state.execution_notes} required="required" placeholder="Enter Execution Notes" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.execution_notes} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Failure Reason</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefailurereasonChange} className="form-control" name="failurereason" value={this.state.failurereason} required="required" placeholder="Enter Failure Reason" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failurereason} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Executed By</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleexecuted_byChange} className="form-control" name="executed_by" value={this.state.executed_by} required="required" placeholder="Enter Executed By" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.executed_by} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Executed On</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handleexecuted_onChange} className="form-control" name="executed_on" value={this.state.executed_on} required="required" placeholder="Enter Executed On" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.executed_on} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Estimated Hours</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleestimated_hoursChange} className="form-control" name="estimated_hours" value={this.state.estimated_hours} required="required" placeholder="Enter Estimated Hours" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.estimated_hours} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Actual Hours</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleactual_hoursChange} className="form-control" name="actual_hours" value={this.state.actual_hours} required="required" placeholder="Enter Actual Hours" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.actual_hours} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Environment</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleenvironmentChange} className="form-control" name="environment" value={this.state.environment} required="required" placeholder="Enter Environment" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.environment} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.IttaskstestcasesupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}